import React, { FC, useEffect, useState } from 'react';
import { SectionWrapper } from '../SectionWraper';
import { BANK_INFORMATION_FAKE_INPUTS } from '../../constants/profile-settings/business-settings-bank-information';
import { useTranslation } from 'react-i18next';
import { IBankAccountInformation } from '../../interfaces/merchant';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { BankFieldsReturnTypes } from '../../constants/merchant/bank-form';
import { FakeInput } from '../form/FakeInput';

const convertToInitialBankData = (data): BankFieldsReturnTypes => ({
	ddaType: data?.bankAccountInformation?.ddaType ? data?.bankAccountInformation?.ddaType : '',
	maskedAccountNumber: data?.bankAccountInformation?.maskedAccountNumber ? data?.bankAccountInformation?.maskedAccountNumber : '',
	maskedRoutingNumber: data?.bankAccountInformation?.maskedRoutingNumber ? data?.bankAccountInformation?.maskedRoutingNumber : '',
	accountNumber: data?.bankAccountInformation?.maskedAccountNumber ? data?.bankAccountInformation?.maskedAccountNumber : '',
	routingNumber: data?.bankAccountInformation?.maskedRoutingNumber ? data?.bankAccountInformation?.maskedRoutingNumber : '',
	bankName: data?.bankAccountInformation?.bankName ? data?.bankAccountInformation?.bankName : '',
});

export const BusinessSettingsBankingDetails: FC = () => {
	const { t } = useTranslation();
	const { merchantState: { merchantData, isMerchantDataLoading }} = useMerchants();
	const [data, setData] = useState<IBankAccountInformation>();

	useEffect(() => {
		if(merchantData) {
			const data: any = convertToInitialBankData(merchantData);
			setData(data);
		}
	}, [merchantData]);

	const INPUTS = BANK_INFORMATION_FAKE_INPUTS({ t, data });

	return (
		<SectionWrapper
			title="Banking details"
			sectionAdditionalClass="mb-5 min-height-200"
			pageLoading={isMerchantDataLoading}
			isCardBody
		>
			<div className="row">
				{
					INPUTS.map(el => (
						<FakeInput key={el.key} {...el} autoComplete="off" />
					))
				}
			</div>
		</SectionWrapper>
	);
};
